import React from "react";
import { useLanguage } from "../../../utils/languageContext";
import "./Newhome.css";

const ScreenReader = () => {
  const { t } = useLanguage();

  const screenReaders = [
    {
      name: t("screenreader.names.nvda"),
      website: "http://www.nvda-project.org/",
      type: t("screenreader.types.free"),
    },
    {
      name: t("screenreader.names.safa"),
      website: "http://www.nabdelhi.org/NAB_SAFA.htm",
      type: t("screenreader.types.free"),
    },
    {
      name: t("screenreader.names.hal"),
      website: "http://www.yourdolphin.co.uk/productdetail.asp?id=5",
      type: t("screenreader.types.commercial"),
    },
    {
      name: t("screenreader.names.supernova"),
      website: "http://www.yourdolphin.co.uk/productdetail.asp?id=1",
      type: t("screenreader.types.commercial"),
    },
  ];

  return (
    <div className="screen-reader-container">
      <h1 className="title">{t("screenreader.title")}</h1>

      <div className="table-wrapper">
        <table className="screen-reader-table">
          <thead>
            <tr>
              <th>{t("screenreader.headers.screenReader")}</th>
              <th>{t("screenreader.headers.website")}</th>
              <th>{t("screenreader.headers.type")}</th>
            </tr>
          </thead>
          <tbody>
            {screenReaders.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>
                  <a href={item.website} target="_blank" rel="noreferrer">
                    {item.website}
                  </a>
                </td>
                <td>{item.type}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ScreenReader;